import { render, staticRenderFns } from "./AbnormalStudentScreening.vue?vue&type=template&id=2f0a8072&scoped=true"
import script from "./AbnormalStudentScreening.vue?vue&type=script&lang=js"
export * from "./AbnormalStudentScreening.vue?vue&type=script&lang=js"
import style0 from "./AbnormalStudentScreening.vue?vue&type=style&index=0&id=2f0a8072&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0a8072",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f0a8072')) {
      api.createRecord('2f0a8072', component.options)
    } else {
      api.reload('2f0a8072', component.options)
    }
    module.hot.accept("./AbnormalStudentScreening.vue?vue&type=template&id=2f0a8072&scoped=true", function () {
      api.rerender('2f0a8072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CommonPage/NotCollectedBasemap/components/AbnormalStudentScreening.vue"
export default component.exports